import React from "react";
import { LandingPageRow } from "../LandingPageSection";
import styled from "@emotion/styled";
import { CustomThemeType } from "../../../../context/Providers";
import CallToActionButton from "../../../../components/CallToActionButton/CallToActionButton";
import SectionFooter from "../SectionFooter";
import { Handshake } from "lucide-react";
import Button from "../../../../components/Button/Button";
import { useWindowSize } from "react-use";

const Col1 = styled.div<{ theme?: CustomThemeType }>`
    width: 35%;
    height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 60px;
    h1 {
        color: ${p => p.theme.foreground};
        padding: 0;
        margin: 0;
        font-size: 4rem;
        font-weight: 500;
    }
    h4 {
        color: color-mix(in srgb, ${p => p.theme.foreground}, ${p => p.theme.background} 50%);
        margin-top: 3rem;
        margin-bottom: 4.5rem;
        font-size: 2rem;
    }
    @media (max-width: 1400px) {
        h1 {
            font-size: 3.5rem;
        }
        h4 {
            font-size: 1.75rem;
            margin-top: 2rem;
            margin-bottom: 3rem;
        }
    }
    @media (max-width: 1100px) {
        h1 {
            font-size: 2.5rem;
        }
        h4 {
            font-size: 1.25rem;
            margin-top: 2rem;
            margin-bottom: 2rem;
        }
    }
    @media (max-width: 1000px) {
        height: 30vh;
    }
    @media (max-width: 800px) {
        width: 60%;
        align-items: center;
        text-align: center;
    }
    @media (max-width: 600px) {
        margin: 2rem;
        width: 80%;
    }
    @media (max-width: 650px) {
        height: auto;
        margin: 4rem 0;
    }
`;

const Col2 = styled.div<any>`
    width: 30%;
    height: 50vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin: 0 60px;
    @media (max-width: 1400px) {
        margin: 0;
    }
    @media (max-width: 1000px) {
        height: 30vh;
    }
    @media (max-width: 800px) {
        display: none;
        width: 40%;
        margin: 0;
    }
`;

const IconStack = styled.div<{theme?: CustomThemeType}>`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    & svg {
        color: ${p => p.theme.brand};
        width: 25rem;
        height: 25rem;
        filter: drop-shadow(10px 10px 5px rgba(0, 0, 0, .3));
    }
    @media (max-width: 1400px) {
        & svg {
            width: 15rem;
            height: 15rem;
        }
    }
    @media (max-width: 1100px) {
        height: 30vh;
        & svg {
            width: 12rem;
            height: 12rem;
        }
    }
    @media (max-width: 1000px) {
        & svg {
            width: 10rem;
            height: 10rem;
        }
    }
`;

interface Section3ContentProps {
    onContactUsClick: () => any;
}

const Section3Content: React.FC<Section3ContentProps> = ({ onContactUsClick }) => {
    const { width } = useWindowSize();
    return (
        <>
            <LandingPageRow height={width > 650 ? "85vh" : "auto"}>
                <Col1>
                    <h1>
                        Leave us a message
                    </h1>
                    <h4>
                        We'd be happy to talk with you. Our priority is to simplify your delivery process while keeping current infrastructure perfectly intact.
                    </h4>
                    <Button size={width > 1400 ? "lg" : width > 1100 ? "md" : "sm"} onClick={() => onContactUsClick()}>Contact Us</Button>
                </Col1>
                <Col2>
                    <IconStack>
                        <Handshake />
                    </IconStack>
                </Col2>
            </LandingPageRow>
        </>
    );
}

export default Section3Content;